import React from "react";
import {
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    IconButton,
    Typography,
} from "@mui/material";

// Components
import Icon from "@/theme/vectors/bundle";

const ProductTable = ({ products, loading, onEdit, onDelete, translate }) => {
    if (!loading && products.length === 0) {
        return (
            <Paper sx={{ p: 3, textAlign: 'center' }}>
                <Typography>{translate('product.noProductsFound', 'No products found')}</Typography>
            </Paper>
        );
    }

    if (products.length === 0) {
        return null;
    }

    return (
        <TableContainer component={Paper}>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell width="50px">#</TableCell>
                        <TableCell>{translate('product.name', 'Name')}</TableCell>
                        <TableCell>{translate('product.created', 'Created')}</TableCell>
                        <TableCell align="right">{translate('common.actions', 'Actions')}</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {products.map((product, index) => (
                        <TableRow key={product.id}>
                            <TableCell>{index + 1}</TableCell>
                            <TableCell>{product.name}</TableCell>
                            <TableCell>
                                {new Date(product.created_at).toLocaleDateString('en-GB', {
                                    day: '2-digit', 
                                    month: '2-digit', 
                                    year: 'numeric'
                                })}
                            </TableCell>
                            <TableCell align="right">
                                <IconButton onClick={() => onEdit(product.id)}>
                                    <Icon name="edit" />
                                </IconButton>
                                <IconButton onClick={() => onDelete(product.id)}>
                                    <Icon name="remove" />
                                </IconButton>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default ProductTable;